import * as yup from 'yup';

export const PERSON_SEARCH_REQUIRED_ERROR_MESSAGE =
  "We'll need a last name to do a search";

export const PERSON_SEARCH_NO_RESULTS_ERROR_MESSAGE =
  'No results found. Please make sure you include a last name and try again.';

export const schemaPersonSearchForm = yup.object({
  name: yup.string().required(PERSON_SEARCH_REQUIRED_ERROR_MESSAGE).trim(),
});
